/**
 * @generated SignedSource<<9bbc412cec1fcda75bc058ad237c9f07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountCodeUsageTable_Refetch$variables = {
  after?: string | null;
  filterByUsedAtFrom?: string | null;
  filterByUsedToFrom?: string | null;
  first: number;
  id: string;
};
export type DiscountCodeUsageTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiscountCodeUsageTable_DiscountCodeFragment">;
};
export type DiscountCodeUsageTable_Refetch = {
  response: DiscountCodeUsageTable_Refetch$data;
  variables: DiscountCodeUsageTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByUsedAtFrom"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByUsedToFrom"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "filterByUsedAtFrom",
  "variableName": "filterByUsedAtFrom"
},
v3 = {
  "kind": "Variable",
  "name": "filterByUsedToFrom",
  "variableName": "filterByUsedToFrom"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscountCodeUsageTable_Refetch",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DiscountCodeUsageTable_DiscountCodeFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscountCodeUsageTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": [
          (v5/*: any*/)
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "SearchDiscountCodeUsagesResult",
                "kind": "LinkedField",
                "name": "searchUsages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "concreteType": "DiscountCodeUsagesConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountCodeUsagesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DiscountCodeUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "at",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Order",
                                "kind": "LinkedField",
                                "name": "order",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "invoiceData",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "invoiceNumber",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "invoiceFile",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              },
                                              (v8/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "CreatedInvoiceData",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "DiscountCodeUsageTable_usages",
                    "kind": "LinkedHandle",
                    "name": "usages"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sumGrossPriceWithDiscounts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sumGrossPriceWithoutDiscounts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "csv",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DiscountCode",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec03ccacb7d73f76c1ad8d4c639e6696",
    "id": null,
    "metadata": {},
    "name": "DiscountCodeUsageTable_Refetch",
    "operationKind": "query",
    "text": "query DiscountCodeUsageTable_Refetch(\n  $after: String\n  $filterByUsedAtFrom: ZonedDateTIme\n  $filterByUsedToFrom: ZonedDateTIme\n  $first: Int!\n  $id: ID!\n) {\n  ...DiscountCodeUsageTable_DiscountCodeFragment_4bpvaK\n}\n\nfragment DiscountCodeUsageTableHeader_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  ...DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment\n  ...DownloadUsageCsvButton_SearchDiscountUsageResultFragment\n}\n\nfragment DiscountCodeUsageTable_DiscountCodeFragment_4bpvaK on Query {\n  node(id: $id) {\n    __typename\n    ... on DiscountCode {\n      searchUsages(after: $after, first: $first, filterByUsedAtFrom: $filterByUsedAtFrom, filterByUsedToFrom: $filterByUsedToFrom) {\n        usages(after: $after, first: $first) {\n          edges {\n            node {\n              ...DiscountCodeUsageTable_DiscountCodeUsageFragment\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        ...DiscountCodeUsageTableHeader_SearchDiscountUsageResultFragment\n      }\n    }\n    id\n  }\n}\n\nfragment DiscountCodeUsageTable_DiscountCodeUsageFragment on DiscountCodeUsage {\n  ...UsageUsedAtColumn_DiscountCodeUsageFragment\n  ...UsageOrderColumn_DiscountCodeUsageFragment\n  ...UsageIdColumn_DiscountCodeUsageFragment\n  ...UsageInvoiceColumn_DiscountCodeUsageFragment\n}\n\nfragment DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  sumGrossPriceWithDiscounts\n  sumGrossPriceWithoutDiscounts\n}\n\nfragment DownloadUsageCsvButton_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  csv\n}\n\nfragment UsageIdColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  id\n}\n\nfragment UsageInvoiceColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  order {\n    invoiceData {\n      __typename\n      ... on CreatedInvoiceData {\n        invoiceNumber\n        invoiceFile {\n          url\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UsageOrderColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  order {\n    id\n  }\n}\n\nfragment UsageUsedAtColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  at\n}\n"
  }
};
})();

(node as any).hash = "a11ba6c0f22423ce42f5aeb398a08e20";

export default node;
